module.exports = __webpack_public_path__ + "img/xcb-subject-mirror5-logo.e9cfe91c.png";